import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "responsive", "children"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled, { css, useTheme } from 'styled-components';
import { GRID_BREAKPOINT_EXTRA_LARGE, GRID_BREAKPOINT_MEDIUM } from '../constants/';
import { jsx as _jsx } from "react/jsx-runtime";
const getBackgroundColor = (color = 'default') => {
  switch (color) {
    case 'light':
      return 'fill-surface-raised';
    case 'dark':
      return 'temp-do-not-use-fill-surface-recessed';
    case 'default':
    default:
      return 'fill-surface-default';
  }
};
const responsiveStylesMixin = props => {
  if (!props.responsive) {
    return '';
  }
  return css(["@media (max-width:", "){padding-block:", ";padding-inline:", ";}@media (max-width:", "){padding-block:", ";padding-inline:", ";}"], GRID_BREAKPOINT_EXTRA_LARGE, ({
    theme
  }) => theme.space['800'], ({
    theme
  }) => theme.space['900'], GRID_BREAKPOINT_MEDIUM, ({
    theme
  }) => theme.space['500'], ({
    theme
  }) => theme.space['600']);
};
const MainSectionContainer = styled.div.withConfig({
  displayName: "MainSection__MainSectionContainer",
  componentId: "sc-9wz71r-0"
})(({
  $spaceCssStyles,
  $color
}) => {
  const theme = useTheme();
  return Object.assign({
    backgroundColor: theme.color[$color],
    paddingBlock: theme.space['1000'],
    paddingInline: theme.space['1100']
  }, $spaceCssStyles);
});
const MainSection = styled(_ref => {
  let {
      color,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(MainSectionContainer, Object.assign({
    $color: getBackgroundColor(color),
    $spaceCssStyles: spaceCssStyles
  }, rest, {
    children: children
  }));
}).withConfig({
  displayName: "MainSection",
  componentId: "sc-9wz71r-1"
})(["", ""], responsiveStylesMixin);
export default MainSection;